import ShareableLinkFiles from './ShareableLinkFiles.component';

export default ShareableLinkFiles;